<template>
    <div class="flex flex-col min-h-screen">
    <HeaderComponent />
      <!-- Careers page content -->
      <main class="flex-1 py-8 px-4 md:px-8 lg:px-20">
        <div class="mx-auto max-w-7xl">
          <h1 class="text-3xl md:text-4xl font-semibold mb-6 ">Seeking a New Opportunity in Salesforce Domain?</h1>
          <h2 class="text-3xl md:text-4xl font-semibold mb-4 ">We're Hiring Full-Time!</h2>
          <p class="text-gray-700 mb-6 ">
            Join our dynamic and growing team at <strong>Arrify</strong>. We believe in fostering talent, embracing diversity, and creating a work environment where every individual can thrive. Whether you're a seasoned professional or just starting out, we might have the perfect role waiting for you.
          </p>
          <div class="">
            <button 
              @click="applyNow" 
              class="bg-red-500 text-white font-bold py-2 px-6 rounded hover:bg-red-600 transition duration-300 ease-in-out"
            >
              Apply Now
            </button>
          </div>
        </div>
      </main>
      <FooterComponent />
    </div>
  </template>
  
  <script setup>
  import { useCommonHead } from '../composables/useCommonHead';
  import HeaderComponent from "../components/Header.vue";
  import FooterComponent from "../components/Footer.vue";
  
  const pageTitle = 'Careers - Join Our Team at Arrify';
  const pageDescription = 'Explore exciting career opportunities at Arrify. Join our team of IT professionals specializing in Salesforce Development and WordPress solutions.';
  const currentUrl = 'https://arrify.com/careers/';
  
  useCommonHead(pageTitle, pageDescription, currentUrl);
  
  function applyNow(){
    window.location.href = 'https://docs.google.com/forms/d/1dmFuFf_bS99nlzaa5o-t7FXLS-8sKNXWwQaJTCauWnI/viewform?edit_requested=true'; 
  }
  </script>
  
  <style scoped>
  /* Careers Page styles */
  </style>